import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Select2OptionData } from 'ng-select2';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Observable, Subject, timer } from 'rxjs';
import { tap, map, take, takeUntil } from 'rxjs/operators';
import { AddUpdateTerminalInteractionViewModel } from '../../models/add-update-terminal-interaction-view-model';
import { AddUpdateTerminalViewModel } from '../../models/add-update-terminal-view-model';
import { ContactDetailsViewModel } from '../../models/contact-details-view-model';
import { CreateResult } from '../../models/create-result';
import { InteractionTypeEnum } from '../../models/interaction-type-enum';
import { TaTermConfigViewModel } from '../../models/ta-term-config-view-model';
import { TerminalSignUpViewModel } from '../../models/terminal-signup-view-model';
import { TerminalContactsViewModel } from '../../models/terminal-contacts-view-model';
import { TerminalInteractionViewModel } from '../../models/terminal-interaction-view-model';
import { TerminalInteractionsViewModel } from '../../models/terminal-interactions-view-model';
import { TerminalParamViewModel } from '../../models/terminal-param-view-model';
import { TerminalViewModel } from '../../models/terminal-view-model';
import { AuthenticationService } from '../../services/authentication.service';
import { CardAcceptorConfigService } from '../../services/card-acceptor-config.service';
import { CommsProfileService } from '../../services/comms-profile.service';
import { PermissionEnum } from '../../services/guards/permissions';
import { MerchantService } from '../../services/merchant.service';
import { ParticipantService } from '../../services/participant.service';
import { ProductProfileService } from '../../services/product-profile.service';
import { TerminalCapabilityService } from '../../services/terminal-capability.service';
import { TerminalConfigService } from '../../services/terminal-config.service';
import { TerminalService } from '../../services/terminal.service';
import { UserDataStoreService } from '../../services/user-data-store.service';
import { DeviceMakeViewModel } from '../../models/device-make-view-model';
import { DeviceModelViewModel } from '../../models/device-model-view-model';
import { TerminalSignUpNotesViewModel } from '../../models/terminal-sign-up-notes';
import { AddUpdateTerminalSignUpViewModel } from '../../models/add-update-terminal-sign-up-view-model';
import { ConfirmationDialogComponent } from '../../partials/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-terminal-card-view',
  templateUrl: './terminal-card-view.component.html',
  styleUrls: ['./terminal-card-view.component.scss']
})
export class TerminalCardViewComponent implements OnInit {

  public TerminalFormGroup: FormGroup;
  public termTypes: Select2OptionData[] = [];
  public productProfiles: Select2OptionData[] = [];
  public capabilityProfiles: Select2OptionData[] = [];
  public commsProfiles: Select2OptionData[] = [];
  public terminalMakeList: DeviceMakeViewModel[];
  public terminalModelList: DeviceModelViewModel[];
  public terminalConfigsSelect2: Select2OptionData[] = [];
  public terminalSignUpNote: TerminalSignUpNotesViewModel;
  public terminalSignUpNotes: TerminalSignUpNotesViewModel[] = [];
  public deviceList: AddUpdateTerminalSignUpViewModel[] = [];
  public parameterDownloadInteractionDays: Select2OptionData[] = [
    { id: "1", text: 'Sunday' },
    { id: "2", text: 'Monday' },
    { id: "4", text: 'Tuesday' },
    { id: "8", text: 'Wednesday' },
    { id: "15", text: 'Thursday' }
  ];
  public terminalInteractionBankingWindowTimes: Select2OptionData[] = [
    { id: "", text: "" },
    { id: "00:00 - 00:30", text: "00:00 - 00:30" },
    { id: "00:30 - 01:00", text: "00:30 - 01:00" },
    { id: "01:00 - 01:30", text: "01:00 - 01:30" },
    { id: "01:30 - 02:00", text: "01:30 - 02:00" },
    { id: "02:00 - 02:30", text: "02:00 - 02:30" },
    { id: "02:30 - 03:00", text: "02:30 - 03:00" },
    { id: "03:00 - 03:30", text: "03:00 - 03:30" },
    { id: "03:30 - 04:00", text: "03:30 - 04:00" },
    { id: "04:00 - 04:30", text: "04:00 - 04:30" },
    { id: "04:30 - 05:00", text: "04:30 - 05:00" },
    { id: "05:00 - 05:30", text: "05:00 - 05:30" },
    { id: "05:30 - 06:00", text: "05:30 - 06:00" },
    { id: "06:00 - 06:30", text: "06:00 - 06:30" },
    { id: "06:30 - 07:00", text: "06:30 - 07:00" },
    { id: "07:00 - 07:30", text: "07:00 - 07:30" },
    { id: "07:30 - 08:00", text: "07:30 - 08:00" },
    { id: "08:00 - 08:30", text: "08:00 - 08:30" },
    { id: "08:30 - 09:00", text: "08:30 - 09:00" },
    { id: "09:00 - 09:30", text: "09:00 - 09:30" },
    { id: "09:30 - 10:00", text: "09:30 - 10:00" },
    { id: "10:00 - 10:30", text: "10:00 - 10:30" },
    { id: "10:30 - 11:00", text: "10:30 - 11:00" },
    { id: "11:00 - 11:30", text: "11:00 - 11:30" },
    { id: "11:30 - 12:00", text: "11:30 - 12:00" },
    { id: "12:00 - 12:30", text: "12:00 - 12:30" },
    { id: "12:30 - 13:00", text: "12:30 - 13:00" },
    { id: "13:00 - 13:30", text: "13:00 - 13:30" },
    { id: "13:30 - 14:00", text: "13:30 - 14:00" },
    { id: "14:00 - 14:30", text: "14:00 - 14:30" },
    { id: "14:30 - 15:00", text: "14:30 - 15:00" },
    { id: "15:00 - 15:30", text: "15:00 - 15:30" },
    { id: "15:30 - 16:00", text: "15:30 - 16:00" },
    { id: "16:00 - 16:30", text: "16:00 - 16:30" },
    { id: "16:30 - 17:00", text: "16:30 - 17:00" },
    { id: "17:00 - 17:30", text: "17:00 - 17:30" },
    { id: "17:30 - 18:00", text: "17:30 - 18:00" },
    { id: "18:00 - 18:30", text: "18:00 - 18:30" },
    { id: "18:30 - 19:00", text: "18:30 - 19:00" },
    { id: "19:00 - 19:30", text: "19:00 - 19:30" },
    { id: "19:30 - 20:00", text: "19:30 - 20:00" },
    { id: "20:00 - 20:30", text: "20:00 - 20:30" },
    { id: "20:30 - 21:00", text: "20:30 - 21:00" },
    { id: "21:00 - 21:30", text: "21:00 - 21:30" },
    { id: "21:30 - 22:00", text: "21:30 - 22:00" },
    { id: "22:00 - 22:30", text: "22:00 - 22:30" },
    { id: "22:30 - 23:00", text: "22:30 - 23:00" },
    { id: "23:00 - 23:30", text: "23:00 - 23:30" }
  ];
  public terminalInteractionParameterTimes: Select2OptionData[] = [
    { id: "23:00 - 23:30", text: "23:00 - 23:30" },
    { id: "23:30 - 00:00", text: "23:30 - 00:00" },
    { id: "00:00 - 00:30", text: "00:00 - 00:30" },
    { id: "00:30 - 01:00", text: "00:30 - 01:00" },
    { id: "01:00 - 01:30", text: "01:00 - 01:30" },
    { id: "01:30 - 02:00", text: "01:30 - 02:00" },
    { id: "02:00 - 02:30", text: "02:00 - 02:30" },
    { id: "02:30 - 03:00", text: "02:30 - 03:00" },
    { id: "03:00 - 03:30", text: "03:00 - 03:30" },
    { id: "03:30 - 04:00", text: "03:30 - 04:00" },
    { id: "04:00 - 04:30", text: "04:00 - 04:30" },
    { id: "04:30 - 05:00", text: "04:30 - 05:00" },
    { id: "05:00 - 05:30", text: "05:00 - 05:30" },
    { id: "05:30 - 06:00", text: "05:30 - 06:00" },
    { id: "06:00 - 06:30", text: "06:00 - 06:30" },
    { id: "06:30 - 07:00", text: "06:30 - 07:00" },
    { id: "07:00 - 07:30", text: "07:00 - 07:30" }
  ];
  public deliveryMethod: string;
  public client: boolean;
  public terminalSignUp: TerminalSignUpViewModel = {
    id: 0,
    changedOn: '',
    changedBy: '',
    source: '',
    merchantName: '',
    merchantNumber: '',
    terminalId: '',
    participantId: 0,
    status: '',
    date: '',
    comments: '',
    wayBill: '',
    data: '',
    trackingId: '',
    priority: '',
    type: '',
    form: '',
    brand: '',
    inUseBy: '',
    inUseById: '',
    inUseDate: '',
    serialNumber: '',
    baseSerialNumber: '',
    simNumber: '',
    dispatch: false,
    deliveryMethod: '',
    retail: '',
    admin: '',
    sameAsMerchantAddress: false,
    make: '',
    model: '',
    bulkOrder: false,
    deviceOwnership:''
  };

  currentUserEmail: string;
  bankingWindowDetail: string;
  parameterDownloadWindowDetail: string;
  weekend: string;
  dispatch = false;
  isCourier = false;
  isOwner = false;
  public submitted = false;
  raiseDanger: boolean;
  danger: string;
  manualPanEntry: boolean;
  confirm = false;
  public createResult: CreateResult;
  public select2options: any = {
    multiple: false,
    width: '100%',
    allowClear: true
  };
  private _destroyed$ = new Subject<any>();
  //public id: string;
  public canAdd: boolean;
  public canEdit: boolean;
  public terminal: TerminalViewModel;
  public taTermCfg: TaTermConfigViewModel;
  public terminalInteractions: TerminalInteractionViewModel[];
  public terminalInteractionsDetails: TerminalInteractionsViewModel[];
  public bankingWindowUpdate: AddUpdateTerminalInteractionViewModel;
  public parameterDownloadWindowUpdate: AddUpdateTerminalInteractionViewModel;
  public terminalUpdate: AddUpdateTerminalViewModel;
  public contactlessTerminalParam: TerminalParamViewModel;
  public contactDetails: TerminalContactsViewModel;
  public TerminalSignUp: TerminalSignUpViewModel;
  buttonSave: boolean;
  public remainingCount$: Observable<number>;
  public remainingCount: number;
  public redirect = false;

  constructor(
    private _terminalConfigService: TerminalConfigService,
    private _commsProfileService: CommsProfileService,
    private _productProfileService: ProductProfileService,
    private _terminalCapabilityService: TerminalCapabilityService,
    private _router: Router,
    private route: ActivatedRoute,
    private _userDataStore: UserDataStoreService,
    private _authenticationService: AuthenticationService,
    private _modalService: NgbModal,
    private _terminalService: TerminalService,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _toastService: ToastrService,
    private _formBuilder: FormBuilder,
    private _cardAcceptorConfigService: CardAcceptorConfigService,
    private _merchantService: MerchantService,
    private _http: HttpClient,
    private _participantService: ParticipantService,
    private _modal: NgbActiveModal) {

    route.params.pipe(takeUntil(this._destroyed$)).subscribe(async params => {
      this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditTerminal], []);
      this.canAdd = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddTerminal], []);
      this.terminalMakeList = await this._terminalService.GetDeviceMakes();
      this.terminalModelList = await this._terminalService.GetDeviceModels();

      this.canAdd = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddTerminal], []);

    });

    this.currentUserEmail = this._userDataStore.currentUserValue.email;
    this.client = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddTerminalSignUpNotes], []);
    
  }

  public ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  public async ngOnInit() {

    this.setupFormGroup();
    this.deliveryMethod = "";
  }

  public async ngAfterViewInit() {

    setTimeout(async () => {
      
      this._ngxUiLoaderService.start();

      this.IsUserAClient();

      await this.updateTerminalStatus();

      this.isCourier = (this.terminalSignUp.deliveryMethod == "Courier" ? true : false);
      this.deliveryMethod = this.terminalSignUp.deliveryMethod

      await this.getTerminal();

      await this.getTerminalContacts();

      this.getTerminalInteractions();

      this.setupFormGroup();

      this._ngxUiLoaderService.stop();


    }, 1000);
  }

  private getTerminalInteractions() {
    let bankingWindow;
    let parameterDownloadWindow;

    if (this.terminalInteractionsDetails.length <= 0) {

      bankingWindow = this.terminalInteractions.find(ti => ti.interactionType == 1);
      parameterDownloadWindow = this.terminalInteractions.find(ti => ti.interactionType == 2);
    }

    bankingWindow = this.terminalInteractions.find(ti => ti.interactionType == 1);
    parameterDownloadWindow = this.terminalInteractions.find(ti => ti.interactionType == 2);

    if (this.terminalInteractionsDetails.length > 0) {
      if (this.terminalInteractionsDetails.find(ti => ti.interactionType == 1) != null) {
        this.bankingWindowDetail = this.terminalInteractionsDetails.find(ti => ti.interactionType == 1).slot;
      }
      if (this.terminalInteractionsDetails.find(ti => ti.interactionType == 2) != null) {
        this.parameterDownloadWindowDetail = this.terminalInteractionsDetails.find(ti => ti.interactionType == 2).slot;
      }
      if (this.terminalInteractions.length > 0) {
        this.weekend = this.terminalInteractions?.find(x => x.weekdays != null).weekdays.toString();

      }
    }

    if (this.taTermCfg != null) {
      this.manualPanEntry = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddManualPanEntry, PermissionEnum.EditManualPanEntry, PermissionEnum.ViewManualPanEntry], []);
    }
    else {
      this.manualPanEntry = false;
    }
  }

  private async getTerminal() {
    this.terminal = await this._terminalService.Get(this.terminalSignUp.terminalId);
    this.terminalInteractions = await this._terminalService.GetTerminalInteractions(this.terminalSignUp.terminalId);
    this.contactlessTerminalParam = await this._terminalService.GetLastContactlessParam(this.terminalSignUp.terminalId);
    this.terminalInteractionsDetails = await this._terminalService.GetTerminalInteractionsDetails(this.terminalSignUp.terminalId);
    this.terminalInteractions = await this._terminalService.GetTerminalInteractions(this.terminalSignUp.terminalId);
  }

  private async getTerminalContacts() {
    this.contactDetails = await this._terminalService.GetTerminalContacts(this.terminalSignUp.terminalId);

    if (this.contactDetails == null && this.terminalSignUp.sameAsMerchantAddress) {

      var merchant = await this._merchantService.GetMerchantDetails(this.terminalSignUp.merchantNumber);
      var contact = await this._merchantService.GetContactDetails(this.terminalSignUp.merchantNumber, this.terminalSignUp.participantId.toString());
      this.contactDetails = {
        address: merchant.merchantStreetAddress,
        cell: merchant.customerServicePhoneNo,
        city: '',
        email: contact?.emailAddress,
        merchantNumber: '',
        nameSurname: contact?.firstName + " " + contact?.surname,
        postalcode: merchant.postalServiceCode,
        region: '',
        terminalId: '',
        country: ''
      };
    }
  }

  private async updateTerminalStatus() {
    debugger;
    if (this.terminalSignUp.status == "New") {
      this.buttonSave = true;
      this.isOwner = true;
      //update terminal status to 'terminal preparation';
      this.terminalSignUp.status = "Terminal preparation";
      await this._terminalService.UpdateTerminalSignedUp(this.terminalSignUp, false);
    }
    else {
      this.isOwner = (this.terminalSignUp.inUseBy == this.currentUserEmail ? true : false);
    
    if (!this.isOwner || this.terminalSignUp.status == "Dispatched") {
      this.TerminalFormGroup.controls['SerialNumberFC'].disable();
      this.TerminalFormGroup.controls['BaseSerialNumberFC'].disable();
      this.TerminalFormGroup.controls['SimNumberFC'].disable();
      this.TerminalFormGroup.controls['dispatch'].disable();
        this.isOwner = false;
    }
   }
  }

  private IsUserAClient() {
    if (this.terminalSignUp.status == "Terminal preparation" && this.client) {
      this.client = true;
    }
    else {
      this.client = false;
    }
  }

  setupFormGroup() {

    this.TerminalFormGroup = this._formBuilder.group({
      merchantNumber: [{ value: this.terminal?.cardAcceptor, disabled: true }, [Validators.required, Validators.minLength(15), Validators.maxLength(15)]],
      terminalId: [{ value: this.terminal?.id, disabled: true }, [Validators.required, Validators.minLength(8), Validators.maxLength(8)]],
      terminalMake: [{ value: this.GetDeviceMake(this.terminalSignUp?.make), disabled: true }, [Validators.required]],
      terminalModel: [{ value: this.GetDeviceModel(this.terminalSignUp?.model), disabled: true }, [Validators.required]],
      retailFC: [{ value: this.terminalSignUp?.retail, disabled: true }],
      adminFC: [{ value: this.terminalSignUp?.admin, disabled: true }],
      terminalNumber: [{ value: this.taTermCfg?.termNr, disabled: true }, [Validators.required, Validators.minLength(1), Validators.maxLength(4)]],
      bankingWindowTimeFC: [{ value: this.bankingWindowDetail, disabled: true }, [Validators.required]],
      parameterDownloadDayFC: [{ value: this.weekend, disabled: true }, [Validators.required]],
      parameterDownloadWindowTimeFC: [{ value: this.parameterDownloadWindowDetail, disabled: true }, [Validators.required]],
      SerialNumberFC: [{ value: this.terminalSignUp?.serialNumber, disabled: false }, Validators.compose([Validators.required])],
      BaseSerialNumberFC: [{ value: this.terminalSignUp?.baseSerialNumber, disabled: false }],
      SimNumberFC: [{ value: this.terminalSignUp?.simNumber, disabled: false }, Validators.compose([Validators.required])],
      ContactNameSurnameFC: [{ value: this.contactDetails?.nameSurname, disabled: true }],
      ContactNameCellNrFC: [{ value: this.contactDetails?.cell, disabled: true }],
      ContactEmailAddressFC: [{ value: this.contactDetails?.email, disabled: true }],
      ContactAddressFC: [{ value: this.contactDetails?.address, disabled: true }],
      dispatch: [{ value: this.terminalSignUp?.dispatch, disabled: false }],
      notesFC: ['']
    });

  }

  public GetDeviceMake(id: string) {
    if (this.terminalMakeList != undefined && parseInt(id) >= 0) {
      const foundItem = this.terminalMakeList?.find(item => item.id === parseInt(id));
      return foundItem.make;
    }
    return "";
  }

  public GetDeviceModel(id: any) {
    if (this.terminalMakeList != undefined && parseInt(id) >= 0) {
      const foundItem = this.terminalModelList?.find(item => item.id === parseInt(id));
      return foundItem.model;
    }
    return "";
  }

  async save() {

    this.submitted = true;
    if (this.TerminalFormGroup.invalid) {
      this.raiseDanger = true;
      this.danger = "The form is invalid. Please ensure that all mandatory fields are filled with the required input.";
    }
    else {
      this.raiseDanger = false;

      this._ngxUiLoaderService.start();


      this.terminalSignUp.serialNumber = this.TerminalFormGroup.controls['SerialNumberFC'].value;
      this.terminalSignUp.baseSerialNumber = this.TerminalFormGroup.controls['BaseSerialNumberFC'].value;
      this.terminalSignUp.simNumber = this.TerminalFormGroup.controls['SimNumberFC'].value;
      var dispatch = this.TerminalFormGroup.controls["dispatch"].value;
      this.createResult = await this._terminalService.UpdateTerminalSignedUp(this.terminalSignUp, dispatch);

      if (this.createResult.success) {
        this._toastService.success(this.createResult.message, "Success");
        this.buttonSave = false;
        this.close();
      }
      else {
        this.raiseDanger = true;
        this.danger = this.createResult.message;
        this._toastService.error(this.createResult.message, "error");
      }
      this._ngxUiLoaderService.stop();
    }
  }

  async SaveNote() {

    this._ngxUiLoaderService.start();
    if ((this.TerminalFormGroup.controls['notesFC'].value) != '') {

      let signUp = {} as AddUpdateTerminalSignUpViewModel;
      signUp.terminalId = this.terminalSignUp.terminalId;
      signUp.merchantNumber = this.terminalSignUp.merchantNumber;

      this.deviceList.push(signUp);

      this.deviceList.forEach((terminal) => {

        this.terminalSignUpNote = {
          merchantNumber: terminal.merchantNumber,
          terminalId: terminal.terminalId,
          notes: this.TerminalFormGroup.controls['notesFC'].value,
          changedBy: '',
          changedOn: new Date,
          source: '',
          id: 0,
          userId: ''
        };

        this.terminalSignUpNotes.push(this.terminalSignUpNote)

      });

      if (this.terminalSignUpNotes.length > 0) {
        this.createResult = await this._terminalService.AddTerminalSignUpNote(this.terminalSignUpNotes);
        if (this.createResult.success) {
          this._toastService.success(this.createResult.message, "Success");
          this.TerminalFormGroup.controls['notesFC'].setValue('');
        }
        else {
          this._toastService.error(this.createResult.message, "Error");
        }
      }
    }
    else {
      this._toastService.error("Please enter a note!", "Error");
    }
    this._ngxUiLoaderService.stop();
  }

  public close() {
    this._modal.close();
  }

  public async viewNotes() {

    this._ngxUiLoaderService.start();
    var notes = await this._terminalService.GetTerminalSignUpNote(this.terminalSignUp.merchantNumber, this.terminalSignUp.terminalId);

    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = false;
    dialogRef.componentInstance.acceptButtonText = "Close";
    dialogRef.componentInstance.title = "Notes";

    var str = [];
    notes.forEach((note) => {

      str.push("<b>User:</b> " + note.changedBy);
      str.push("<b>Date:</b> " + note.changedOn);
      str.push("<b>Note:</b> " + note.notes);
      str.push("======================================================");
    });

    if (str.length == 0) {
      str.push("NO COMMENTS AVAILABLE.");
    }
    dialogRef.componentInstance.listMessage = str;


    this._ngxUiLoaderService.stop();
  }

}
